// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"jA-z","tooltipWrapper":"kA-z","icon":"lA-z","tooltip":"mA-z","content":"nA-z"};